import React, { ReactNode } from 'react';
import { Col, Row, Typography } from 'antd';
import { Icon, Modal } from '@common/components';
import { FontWeight } from '@common/tokens';

const { Title } = Typography;

type Props = {
  visible: boolean;
  type: 'success' | 'error';
  message: ReactNode;
  title: ReactNode;
  onOk: () => void;
  loading?: boolean;
  onCancel?: () => void;
};

export function RatesLongTermConfirmationModal({
  type,
  title,
  message,
  ...props
}: Props) {
  const isSuccessType = type === 'success';
  return (
    <Modal
      preventClose={isSuccessType}
      className="long-term-message-modal"
      hideCancelButton={isSuccessType}
      okText={isSuccessType ? 'Continue' : 'Try again'}
      {...props}
    >
      <Row>
        <Col span={2}>
          {isSuccessType ? (
            <Icon icon="checkCircle" color="grassMid" size="xl" />
          ) : (
            <Icon icon="xmarkCircle" color="coral" size="xl" />
          )}
        </Col>
        <Col span={22}>
          <Title level={4} style={{ fontWeight: FontWeight.bold }}>
            {title}
          </Title>
          <div>{message}</div>
        </Col>
      </Row>
    </Modal>
  );
}
